import React from 'react';
import PropTypes from 'prop-types';
import { ProviderDate } from '@bagonboard/ui-kit';
import { isDestinationService, SERVICE_TYPES } from '@bagonboard/wiseman';

import getAddress from '../../../../../modules/getAddress';
import { Address, Container, Text } from './style';

// TODO if the to is poi show the poi name and not "Address"
const Delivery = ({
  original: {
    areas, flightInfo = {}, to, type,
  }, value,
}) => {
  const [{ timezone }] = areas;
  const { city, street } = to ? getAddress(to) || {} : {};
  let addressToShow;

  if (isDestinationService(type)) {
    addressToShow = !city && !street ? null : `${street}, ${city}`;
  } else {
    const {
      origin: {
        airportCode,
        terminal,
      } = {},
    } = flightInfo;
    addressToShow = `${airportCode} ${terminal ? `Terminal ${terminal.number}` : 'No terminal'}`;
  }

  return (
    <Container>
      <Text>{ProviderDate.timezoneVerbose(value, timezone, 'HH:mm - DD/MM/YYYY')}</Text>
      {addressToShow ? (
        <Address
          href={`https://www.google.com/maps/search/${addressToShow}`}
          target="_blank"
        >
          {addressToShow}
        </Address>
      )
        : <b>None</b>

      }
    </Container>
  );
};

Delivery.propTypes = {
  classes : PropTypes.shape({}).isRequired,
  original: PropTypes.shape({}),
  value   : PropTypes.string,
};

Delivery.defaultProps = {
  original: {
    flightInfo: {
      origin: {
        terminal: {},
      },
    },
  },
  value: '',
};

export default Delivery;
